import _ from 'lodash'

/**
 * Checks, whether both arrays contains the same IDs
 * (regardless the number of occurrences and order of each value)
 * @param {Array} array1 first array
 * @param {Array} array2 second array
 * @returns {boolean}
 */
export function sameIdsIn (array1, array2) {
  if (!array1 || !array2) {
    return false
  }

  return _.isEmpty(_.xor(array1, array2))
}
